import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DialogService } from 'src/app/services/dialog.service';
import { VideoconsultaBackendService } from 'src/app/services/videoconsulta-backend.service';
import { Params } from 'src/app/types/Params';

@Component({
  selector: 'app-bienvenida',
  templateUrl: './bienvenida.component.html',
  styleUrls: ['./bienvenida.component.css'],
})
export class BienvenidaComponent implements OnInit {
  activeBtn: boolean = true;
  queryParams: any;

  constructor(
    private route: ActivatedRoute,
    private _videoconsulta: VideoconsultaBackendService,
    private router: Router,
    private _spinner: NgxSpinnerService,
    private _dialog: DialogService
  ) {}

  private checkCid(resp: Params) {
    if (!resp.cid) return;

    this._spinner.show();
    this._videoconsulta.checkCid(resp.cid).subscribe({
      next: (body) => {
        if (body.status === 200) {
          this._spinner.hide();
          if (this.queryParams.m == 1) this.navigateToVC();
        }
      },
      error: (err) => {
        if (err.status === 400) {
          this._spinner.hide();
          this.router.navigate(['/finalizado'], {
            state: { cid: resp.cid, m: resp.m },
          });
        }
      },
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      let payload = params['p'];
      this.queryParams = { p: params['p'] };
      if (payload) {
        payload = payload.replace(/\s/g, '+');
      }

      this._videoconsulta.sendPayload(payload).subscribe({
        next: (resp) => {
          this.checkCid(resp);
        },
      });
    });
  }

  navigateToVC(): void {
    this.router.navigate(['/videoconsulta'], { queryParams: this.queryParams });
  }

  checboxChange(event: Event) {
    this.activeBtn = (event.target as HTMLInputElement).checked;
  }

  goToVC() {
    this.router.navigate(['/videoconsulta'], { queryParams: this.queryParams });
  }

  openTycs() {
    this._dialog.createDialog('tycs');
  }
}
